module.exports = __webpack_public_path__ + "img/portis@3x.68bb8434.png";